import React from 'react';
import c from 'classnames';
import { PapiGallection } from '@wix/da-papi-types';
import DiscountLabel from '@wix/da-shared-react/pkg/DiscountLabel';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';

import s from './PremiumFolderPrice.scss';

interface Props {
  className?: string;
  folder: PapiGallection;
}

const PremiumFolderPrice: React.FC<Props> = ({ className, folder }) => {
  if (!folder.premiumFolderData) {
    return null;
  }
  const {
    formattedDollarPrice,
    formattedDollarPriceAfterDiscount,
    isPaidFolder,
    eligibleDiscount,
  } = normalizePremiumFolderData(folder.premiumFolderData);

  return (
    <div className={c(s['root'], className)}>
      {isPaidFolder && eligibleDiscount && (
        <>
          <DiscountLabel
            className={s['discount-label']}
            discount={eligibleDiscount}
          />
          <div className={s['price']}>{formattedDollarPriceAfterDiscount}</div>
          <div className={s['old-price']}>{formattedDollarPrice}</div>
        </>
      )}
      {isPaidFolder && !eligibleDiscount && (
        <div className={s['price']}>{formattedDollarPrice}</div>
      )}
    </div>
  );
};
PremiumFolderPrice.displayName = 'PremiumFolderPrice';

export default PremiumFolderPrice;
